import React from 'react'
import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getToken } from 'shared/util/storage'

const PublicRoute = ({ children }) => {
  return getToken() ? <Navigate to="/" replace /> : children
}

PublicRoute.propTypes = {
  children: PropTypes.node
}

export default PublicRoute
